<script>
import AddBucketsRecord from '@/layer/components/AddBucketsRecord.vue'

export default {
  components: {
    AddBucketsRecord,
  },
}
</script>

<template>
  <add-buckets-record />
</template>



// WEBPACK FOOTER //
// src/layer/views/AddBucketsRecordView.vue